
import { Component, Prop, Vue } from "vue-property-decorator";
import ContainerFrame from "@/components/ContainerFrame.vue";
import StationSummaryFrame from "./StationSummaryFrame.vue";
import { StationSummary } from "@/api/dtos/StationSummary.schema";
import AddButton from "@/components/buttons/AddButton.vue";
import { OperatorSummary } from "@/api/dtos/Station.schema";
import { User } from "@/api/dtos/User.schema";
import { UsersModule } from "@/store/modules/UsersModule";

@Component({
  components: {
    ContainerFrame,
    StationSummaryFrame,
    AddButton,
  },
})
export default class StationsContainerFrame extends Vue {
  @Prop()
  width!: number;

  @Prop()
  height!: number;

  @Prop()
  operator!: OperatorSummary;

  @Prop()
  stations!: StationSummary[];

  get localUser(): User | null {
    return UsersModule.localUser;
  }

  onTitleClick(): void {
    const user = this.localUser;

    if (!user) return;

    const id = user.uuid;

    if (!user.isAdmin && !this.operator.owners.includes(id)) {
      return;
    }

    this.$router.push("/operator/" + this.operator.uuid);
  }
}
